import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SmsBroadcastFragment as SmsBroadcast,
    GetSmsBroadcast as GetSmsBroadcastQuery,
    GetSmsBroadcastVariables as GetSmsBroadcastQueryVariables,
} from 'nutshell-graphql-types';

import Get_SMS_BROADCAST from '../queries/get-sms-broadcast.graphql';

export const useGetSmsBroadcast = (
    broadcastId?: string | null
): {
    smsBroadcast: SmsBroadcast | null | undefined;
    isLoading: boolean;
    errorMessage: string | null | undefined;
} => {
    const {data, error, loading} = useQuery<GetSmsBroadcastQuery, GetSmsBroadcastQueryVariables>(
        Get_SMS_BROADCAST,
        {
            skip: !broadcastId,
            // @ts-expect-error
            variables: {broadcastId},
            fetchPolicy: 'cache-and-network',
        }
    );

    const smsBroadcast = data ? data.smsBroadcast : null;

    return {
        smsBroadcast,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
    };
};
